import { render, staticRenderFns } from "./ReceptionContactView.vue?vue&type=template&id=b35eb8ca&scoped=true&"
import script from "./ReceptionContactView.vue?vue&type=script&lang=ts&"
export * from "./ReceptionContactView.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionContactView.vue?vue&type=style&index=0&id=b35eb8ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35eb8ca",
  null
  
)

export default component.exports